/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Sessions_CountInputs */

const en_us2_draft_sessions_count = /** @type {(inputs: Draft_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 workout`);
	return /** @type {LocalizedString} */ (`${i?.count} workouts`)
	
};

const pt_br2_draft_sessions_count = /** @type {(inputs: Draft_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 treino`);
	return /** @type {LocalizedString} */ (`${i?.count} treinos`)
	
};

const es_419_draft_sessions_count = /** @type {(inputs: Draft_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entrenamiento`);
	return /** @type {LocalizedString} */ (`${i?.count} entrenamientos`)
	
};

const pt_pt2_draft_sessions_count = /** @type {(inputs: Draft_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 treino`);
	return /** @type {LocalizedString} */ (`${i?.count} treinos`)
	
};

const fr_fr2_draft_sessions_count = /** @type {(inputs: Draft_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 séance`);
	return /** @type {LocalizedString} */ (`${i?.count} séances`)
	
};

const de_de2_draft_sessions_count = /** @type {(inputs: Draft_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Einheit`);
	return /** @type {LocalizedString} */ (`${i?.count} Einheiten`)
	
};

const it_it2_draft_sessions_count = /** @type {(inputs: Draft_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 allenamento`);
	return /** @type {LocalizedString} */ (`${i?.count} allenamenti`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 workout" |
* | * | "{count} workouts" |
*
* @param {Draft_Sessions_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_sessions_count = /** @type {((inputs: Draft_Sessions_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Sessions_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_sessions_count(inputs)
	if (locale === "es-419") return es_419_draft_sessions_count(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_sessions_count(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_sessions_count(inputs)
	if (locale === "de-DE") return de_de2_draft_sessions_count(inputs)
	if (locale === "it-IT") return it_it2_draft_sessions_count(inputs)
	return en_us2_draft_sessions_count(inputs)
});
export { draft_sessions_count as "draft.sessions_count" }